import { render, staticRenderFns } from "./VisitsList.vue?vue&type=template&id=6d04856b&"
import script from "./VisitsList.vue?vue&type=script&lang=js&"
export * from "./VisitsList.vue?vue&type=script&lang=js&"
import style0 from "./VisitsList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports